import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Injectable } from "@angular/core";
import { CredentialService } from "../credential.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private credentialService: CredentialService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const token = this.credentialService.getToken();
    const user = this.credentialService.getUser();
    if (user && token) {
      return this.credentialService.isSelectorSession() ? this.router.parseUrl(this.credentialService.getPostLoginUrl()) : true;
    } else {
      this.credentialService.logout(state.url);
      return false;
    }
  }
}
